<template>
    <div class="agent-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">招标公告发布</h2>
            </div>
            <div style="display: flex; gap: 12px;">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="noticeList" border style="width: 100%" class="data-table" v-loading="loading">
                <el-table-column prop="tenderNoticeCode" label="公告编号" show-overflow-tooltip />
                <el-table-column prop="tenderNoticeName" label="公告名称" show-overflow-tooltip />
                <el-table-column prop="noticeType" label="公告类型" width="120" align="center">
                    <template slot-scope="scope">
                        {{ getNoticeTypeName(scope.row.noticeType) }}
                    </template>
                </el-table-column>
                <el-table-column prop="noticeNature" label="公告性质" width="100" align="center">
                    <template slot-scope="scope">
                        {{ getNoticeNatureName(scope.row.noticeNature) }}
                    </template>
                </el-table-column>
                <el-table-column prop="noticeSendTime" label="发布时间" width="180" align="center" />
                <el-table-column prop="status" label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="getStatusType(scope.row.status)" size="small">
                            {{ getStatusName(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleView(scope.row)" class="action-btn">
                            查看详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页组件 -->
            <div class="pagination-wrapper">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total" background />
            </div>
        </div>
    </div>
</template>

<script>
import { Api_GetSemiProcessList } from '@/api/modules/semiProcess'
export default {
    name: 'BidAnnouncementPublish',
    data() {
        return {
            projectCode: this.$route.query.projectCode,
            noticeList: [],
            loading: false,
            pageNum: 1,
            pageSize: 10,
            total: 0
        }
    },
    mounted() {
        this.getNoticeList()
    },
    methods: {
        /**
         * 获取招标公告列表
         */
        getNoticeList() {
            this.loading = true
            Api_GetSemiProcessList({
                projectCode: this.projectCode,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }).then(res => {
                this.loading = false
                if (res.code === 200) {
                    this.noticeList = res.data.records || []
                    this.total = res.data.total || 0
                } else {
                    this.$message.error(res.msg || '获取招标公告列表失败')
                }
            }).catch(() => {
                this.loading = false
            })
        },

        // 每页条数变化
        getStatusName(status) {
            const statusMap = {
                0: '暂存',
                1: '提交',
                2: '退回',
                9: '发布'
            }
            return statusMap[status] || '未知'
        },

        // 状态标签类型
        getStatusType(status) {
            const typeMap = {
                0: 'info',
                1: 'warning',
                2: 'danger',
                9: 'success'
            }
            return typeMap[status] || 'info'
        },

        // 返回项目流程界面
        handleBack() {
            this.$router.go(-1)
        },

        // 公告类型名称映射
        getNoticeTypeName(noticeType) {
            const typeMap = {
                1: '招标公告',
                2: '资格预审公告',
                3: '中标公告',
                9: '其他'
            }
            return typeMap[noticeType] || '-'
        },

        // 公告性质名称映射
        getNoticeNatureName(noticeNature) {
            const natureMap = {
                1: '正常公告',
                2: '变更公告'
            }
            return natureMap[noticeNature] || '-'
        },

        // 查看详情
        handleView(row) {
            this.$router.push({
                path: '/bidderHome/bidAnnouncementPublishDetail',
                query: {
                    projectName: row.projectName,
                    projectCode: row.projectCode,
                    tenderNoticeCode: row.tenderNoticeCode
                }
            })
        },

        // 每页条数变化
        handleSizeChange(val) {
            this.pageSize = val
            this.pageNum = 1
            this.getNoticeList()
        },

        // 当前页变化
        handleCurrentChange(val) {
            this.pageNum = val
            this.getNoticeList()
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 20px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @primary-color;
            border-radius: 2px;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;

        &:hover {
            transform: translateY(-1px);
        }

        &:active {
            transform: translateY(0);
        }
    }
}

.table-section {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
}

.pagination-wrapper {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}

/deep/ .action-btn {
    font-weight: 500;

    &:hover {
        color: @primary-color;
    }
}
</style>